/**
 * Функция для генерации номеров отображаемых на UI страниц
 *
 * @param currentPage Текущая страница, больше нуля и меньше общего количества страниц
 * @param totalPages Общее количество страниц, больше нуля
 * @returns Объект с ключами head и tail, содержащими массивы номеров страниц, доступных для перехода
 */
export const generatePagesNumbers = (
  currentPage: number,
  totalPages: number
): { head: number[]; tail: number[] } => {
  if (currentPage <= 0 || totalPages < 0 || currentPage > totalPages) {
    throw new Error("Некорректные параметры");
  }

  const MAX_PANEL_PAGES = 5;
  const FIRST_PAGE_NUMBER = 1;

  const head: number[] = [];
  const tail: number[] = [];

  for (
    let i = FIRST_PAGE_NUMBER;
    i <= Math.min(totalPages, MAX_PANEL_PAGES - 1) &&
    head.length + tail.length < MAX_PANEL_PAGES - 1;
    i++
  ) {
    const prevPageNumber = currentPage - i;
    const nextPageNumber = currentPage + i;

    if (prevPageNumber > 0) {
      head.push(prevPageNumber);
    }

    if (nextPageNumber <= totalPages) {
      tail.push(nextPageNumber);
    }
  }

  return { head: head.sort((a, b) => a - b), tail };
};
